import React, { useContext } from 'react';
import { DestinationContext } from '../../../contexts/DestinationContext';
import styles from './GuestVoices.module.scss';

const initials = (name = '') =>
  name
    .split(' ')
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

const GuestVoices = () => {
  const destination = useContext(DestinationContext);
  const guestVoices = destination?.guestVoices;
  const testimonials = guestVoices?.testimonials;

  if (!guestVoices || !Array.isArray(testimonials) || testimonials.length === 0) return null;

  return (
    <section className={styles.section}>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <div className={styles.eyebrow}>{guestVoices.eyebrow}</div>
          <h2 className={styles.heading} dangerouslySetInnerHTML={{ __html: guestVoices.title }} />
        </div>
        <div className={styles.grid}>
          {testimonials.map((t, i) => (
            <article className={styles.card} key={t.name || i}>
              <div className={styles.quoteMark}>”</div>
              <p>{t.quote}</p>
              <div className={styles.who}>
                <span className={styles.avatar}>{initials(t.name)}</span>
                <span className={styles.name}>
                  <b>{t.name}</b>
                  {t.location && <span>{t.location}</span>}
                </span>
                {t.source && <span className={styles.source}>{t.source}</span>}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GuestVoices;
